var link_viewer_wrapper_rtlignore_default = {
  "anchor": "IpQTf",
  "link": "-dHD1"
};
export {
  link_viewer_wrapper_rtlignore_default as default
};
//# sourceMappingURL=link-viewer-wrapper.rtlignore-scss.js.map
